<script setup lang="ts">
import { ref, watch, onUnmounted } from 'vue';
import { useWs } from '@/shell/stores/ws';

const ws = useWs();
const showBanner = ref(false);
let timer: ReturnType<typeof setTimeout> | null = null;

watch(
  () => ws.isDisconnected,
  (disconnected) => {
    if (disconnected) {
      timer = setTimeout(() => { showBanner.value = true; }, 2000);
    } else {
      if (timer) { clearTimeout(timer); timer = null; }
      showBanner.value = false;
    }
  },
  { immediate: true },
);
onUnmounted(() => { if (timer) { clearTimeout(timer); timer = null; } });
</script>

<template>
  <div
    v-if="showBanner"
    class="connection-lost"
    role="status"
    aria-live="polite"
    data-testid="connection-lost-banner"
  >
    <i
      class="pi pi-wifi"
      aria-hidden="true"
    />
    <span>Reconnecting…</span>
  </div>
</template>

<style scoped>
.connection-lost {
  display: flex;
  align-items: center;
  gap: var(--app-space-8);
  padding: var(--app-space-8) var(--app-space-16);
  background: var(--app-warning);
  color: var(--app-text-primary);
  font-size: var(--app-font-size-body-sm);
  line-height: var(--app-line-height-body-sm);
  font-weight: var(--app-font-weight-medium);
}
</style>
